import initialState from "./initialState";

export function PollingPoliciesReducer(
  state = initialState.PollingPoliciesReducer,
  action
) {
  switch (action.type) {
    case "SEARCH_POLLING_POLICIES_REQUEST":
      return action.payload;

    default:
      return state;
  }
}
